import React, { useState } from 'react';
import Button from '../../components/Button';
import Form, { Field, Submit } from '../../components/Form';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import SettingCard from '../../settings/SettingCard';
import * as styles from './BillingEmailCard.module.scss';

const BILLING_EMAIL_FRAGMENT = gql(`
  fragment BillingEmailCard_billingSummary on BillingSummary {
    id
    # eslint-disable-next-line @graphql-eslint/require-selections
    customer {
      email
    }
  }
`);

interface BillingEmailCardProps {
  billingSummary: DocumentType<typeof BILLING_EMAIL_FRAGMENT>;
  updateBilling: (values: { email?: string }) => Promise<unknown>;
}

type EmailFormValues = { email: string };

const BillingEmailCard = ({
  billingSummary,
  updateBilling,
}: BillingEmailCardProps) => {
  const [isEditing, setEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { email } = billingSummary.customer;

  const handleSubmit = async (values: EmailFormValues) => {
    setIsSaving(true);

    try {
      await updateBilling(values);
    } finally {
      setIsSaving(false);
      setEditing(false);
    }
  };

  if (isEditing) {
    return (
      <SettingCard
        title="Billing email"
        description={
          <Form<EmailFormValues>
            onSubmit={handleSubmit}
            initialValues={{ email }}
          >
            {({ values }) => (
              <div className={styles.fieldContainer}>
                <Field
                  className={styles.field}
                  name="email"
                  type="email"
                  placeholder="Enter your email address"
                  autoComplete="email"
                  margin="none"
                  autoFocus
                  required
                />
                <div>
                  <Submit
                    disabled={
                      !values.email || values.email === email || isSaving
                    }
                    variant="primary"
                  >
                    Save
                  </Submit>
                </div>
              </div>
            )}
          </Form>
        }
      />
    );
  }

  return (
    <SettingCard
      actions={
        <Button variant="secondary" onClick={() => setEditing(true)}>
          Edit
        </Button>
      }
      title="Billing email"
      details={email}
    />
  );
};

export default BillingEmailCard;
